<template>
  <div class="login-box">
    <div class="login-center">
      <div class="login-left"><img class="login-bg" src="../assets/1.png" /></div>
      <!-- 登录注册 -->
      <div class="login-right" v-if="isLogin">
        <!-- tab -->
        <div class="right-head-tab">
          <div :class="status === 1 ? 'tab-act' : ''" style="margin-right: 20px" @click="status = 1">
            <div>账号登录</div>
            <div class="line-login" v-if="status === 1"></div>
          </div>
          <div v-if="false" :class="status === 2 ? 'tab-act' : ''" @click="status = 2">
            <div>注册账号</div>
            <div class="line-login" v-if="status === 2"></div>
          </div>
        </div>
        <!--  -->
        <div class="form-box">
          <el-form ref="form" :model="form" label-width="0px">
            <el-form-item>
              <el-input :placeholder="status === 1 ? '请输入公司名称' : '请使用公司全称作为用户名,否则影响后期审核'" prefix-icon="el-icon-user"
                v-model="form.accountNumber" />
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入密码" show-password prefix-icon="el-icon-unlock" v-model="form.password" />
            </el-form-item>
            <el-form-item v-if="status === 2">
              <el-input placeholder="请确认密码" show-password prefix-icon="el-icon-unlock" v-model="form.password1" />
            </el-form-item>
            <el-form-item>
              <div class="flex">
                <el-input style="width: 188px" placeholder="请输入验证码" v-model="form.code" />
                <div class="verificationCode-img" @click="qiehuan()"><img :src="imgUrl" /></div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!--  -->
        <div class="wjmm" @click="isLogin = false">忘记密码？</div>
        <!-- 登录按钮 -->
        <el-button class="login-btn" type="primary" @click="login">{{ status === 1 ? '登录' : '注册' }}</el-button>
        <!--  -->
        <div class="foot-box">
          <el-checkbox v-model="checked" style="margin: 0 5px 0 0;"></el-checkbox>
          <div>阅读并接受</div>
          <div class="color" v-for="(item, index) in protocolList" :key="index" @click="zr(item)">《{{ item.title }}》
          </div>
          <!-- <div class="color" @click="zr(2)">《廉洁协议》</div>

          <div class="color" @click="zr(3)">
            <span style="color: #000;margin-right: 2px;">和</span>《保密协议》
          </div> -->
        </div>
      </div>
      <!-- 忘记密码 -->
      <div class="login-right" v-else style="padding: 45px 60px;">
        <h3 style="text-align: center;font-size: 20px;">重置密码</h3>
        <div style="margin-top: 20px;">
          <el-form ref="resetForm" :model="resetForm" label-width="0px">
            <el-form-item>
              <el-input placeholder="请输入公司名称" prefix-icon="el-icon-user" v-model="resetForm.account" />
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入密码" show-password prefix-icon="el-icon-unlock" v-model="resetForm.password" />
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请确认密码" show-password prefix-icon="el-icon-unlock"
                v-model="resetForm.password_confirm" />
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" v-model="resetForm.mobile" />
            </el-form-item>
            <el-form-item>
              <div class="flex">
                <el-input style="width: 188px" placeholder="请输入短信验证码" v-model="resetForm.sm_code" />
                <el-button style="margin-left: 10px;" @click="sendCode" v-if="isCount">发送验证码</el-button>
                <el-button type="info" style="margin-left: 10px;" disabled v-else>{{ count }}</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="flex">
                <el-input style="width: 188px" placeholder="请输入验证码" v-model="resetForm.code" />
                <div class="verificationCode-img" @click="qiehuan()"><img :src="imgUrl" /></div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="wjmm" @click="isLogin = true">返回登录</div>
        <el-button class="login-btn" type="primary" @click="resetPassword">确认重置</el-button>


      </div>
    </div>
    <img class="foot-img" src="../assets/2.png" />
    <div class="foot-tel">
      <p>注册咨询：0592-5611052</p>
      <p>技术问题：0592-5371511</p>
    </div>
    <!-- 廉洁协议 -->
    <el-dialog :title="protocolItem.title" :visible.sync="show" width="50%">
      <span v-html="protocolItem.content" />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="show = false">取 消</el-button> -->
        <el-button type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api8, api9, api11, getProtocolList, sendCode, forgetPassword } from '@/api/index.js'

export default {
  data() {
    return {
      ljxyData: '',
      count: 60,
      resetForm: {
        account: '',
        password: '',
        password_confirm: '',
        mobile: '',
        sm_code: '',
        code: ''
      },
      isLogin: true,
      isCount: true,
      aqzrsData: '',
      bmxyData: '',
      xyType: '',
      show: false,
      checked: false,
      status: 1,
      // imgUrl: 'http://srm.xmstm.com.cn/api/Captcha/create?num=1',
      imgUrl: 'http://kejiguan.huudon.cn/api/Captcha/create?num=1',
      form: {
        accountNumber: '',
        password: '',
        password1: '',
        code: ''
      },
      suijiNum: '',
      protocolList: [],
      protocolItem: {
        title: ''
      }
    }
  },
  watch: {
    status() {
      this.form = {
        accountNumber: '',
        password: '',
        password1: '',
        code: '',

      }
    }
  },
  created() {
    if (localStorage.getItem('userInfo') !== null) {
      this.$router.push('/home')
    }
  },
  mounted() {
    this.qiehuan()
    this.lianjie()
  },
  methods: {
    zr(item) {
      this.protocolItem = item
      this.show = true
    },
    lianjie() {
      getProtocolList().then(res => {
        if (res.data.code === 1) {
          let data = res.data.data
          this.protocolList = data
          console.log('廉洁协议', data)
        } else {
          this.$message.error(res.data.msg)
        }
      })
      // api8().then(res => {
      //   if (res.data.code === 1) {
      //     this.ljxyData = res.data.data.privacy_content

      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
      // api9().then(res => {
      //   if (res.data.code === 1) {
      //     this.aqzrsData = res.data.data.service_content
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
      // api11().then(res => {
      //   if (res.data.code === 1) {
      //     this.bmxyData = res.data.data.password_content
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
    qiehuan() {
      this.suijiNum = Math.random()
      // this.imgUrl = `http://srm.xmstm.com.cn/api/Captcha/create?num=${this.suijiNum}`
      this.imgUrl = `http://kejiguan.huudon.cn/api/Captcha/create?num=${this.suijiNum}`
    },
    jiaoyanImg() {
      return this.$axios.get(`${this.$httpHead}api/Captcha/check?key=${this.suijiNum}&code=${this.form.code || this.resetForm.code}`).then(res => {
        if (res.data.code === 1) {
          return true
        } else {
          this.$message.error('图形验证码错误')
          this.qiehuan()
          return false
        }
      })
    },
    async resetPassword() {
      if (this.resetForm.password === '' || this.resetForm.account === '' || this.resetForm.mobile === '') {
        this.$message.error('账号/密码/手机号不能为空')
        return false
      } else if (this.resetForm.code === '' || this.resetForm.sm_code === '') {
        this.$message.error('短信/图形不能为空')
        return false
      }

      let isSuccess = await this.jiaoyanImg()
      if (isSuccess) {
        forgetPassword(this.resetForm).then(res => {
          if (res.data.code === 1) {
            this.$message.success(res.data.msg)
            this.isLogin = true
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          this.$message.error(err.msg)
        })

      }


    },
    sendCode() {
      const reg = /^1[3456789]\d{9}$/
      console.log(this.resetForm.mobile)
      if (reg.test(this.resetForm.mobile)) {
        const timeout = setInterval(() => {
          this.count--
          if (this.count === 0) {
            this.count = 60
            this.isCount = true
            clearInterval(timeout)
          } else {
            this.isCount = false
          }
        }, 1000)

        sendCode({ mobile: this.resetForm.mobile, scene: 'ZHDLMM', account: this.resetForm.account }).then(res => {
          if (res.data.code === 1) {
            this.$message.success(res.data.msg)
          } else {
            this.count = 60
            this.isCount = true
            clearInterval(timeout)
            this.$message.error(res.data.msg)
          }

        }).catch(err => {
          this.$message.error('发送失败，请重试')
        })

      } else {
        this.$message.warning('请输入正确的手机号')
      }




    },

    async login() {
      // 登录
      if (this.status === 1) {
        if (this.form.password === '' || this.form.accountNumber === '' || this.form.code === '') {
          this.$message.error('账号/密码/验证码不能为空')
          return
        }
      } else {
        if (this.form.password === '' || this.form.password1 === '' || this.form.accountNumber === '' || this.form.code === '') {
          this.$message.error('账号/密码/验证码不能为空')
          return
        }
      }
      if (this.checked) {
        let codeJy = await this.jiaoyanImg()// 验证码校验
        if (codeJy) {
          if (this.status === 1) {
            // 登录
            this.$axios.post(`${this.$httpHead}api/Login/account`, {
              account: this.form.accountNumber,
              password: this.form.password,
              terminal: 1
            }).then(res => {
              if (res.data.code === 1) {
                // 登录成功
                localStorage.setItem('userInfo', JSON.stringify(res.data.data))
                localStorage.setItem('token', res.data.data.token)
                this.$message.success('登录成功')
                setTimeout(() => {
                  this.$router.push('/home')
                }, 2000)
              } else {
                this.qiehuan()
                this.$message.error(res.data.msg)
              }
            })
          } else {
            // 注册
            this.$axios.post(`${this.$httpHead}api/Login/register`, {
              account: this.form.accountNumber,
              password: this.form.password,
              password_confirm: this.form.password1
            }).then(res => {
              if (res.data.code === 1) {
                // 注册成功
                this.$message.success(res.data.msg)
                this.qiehuan()
                this.status = 1
              } else {
                this.qiehuan()
                this.$message.error(res.data.msg)
              }
            })
          }
        }
      } else {
        this.$message.warning('请勾选协议')
      }
    }
  }
}
</script>

<style scoped>
>>>.el-dialog__body {
  max-height: 500px;
  overflow: scroll;
}

.foot-img {
  width: 100vw;
  height: 277px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
}

.foot-box {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 20px;
}

.color {
  color: #1982e4;
  cursor: pointer;
}

.login-btn {
  width: 334px;
  height: 48px;
  /* background: #F0F2F6; */
  border-radius: 2px 2px 2px 2px;
  font-weight: 400;
  font-size: 14px;
  /* color: #999999; */
}

.wjmm {
  font-size: 16px;
  color: #1982e4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0;
  cursor: pointer;
}

.form-box {
  margin-top: 100px;
}

.verificationCode-img>img {
  width: 133px;
  height: 40px;
}

.verificationCode-img {
  width: 133px;
  height: 40px;
  border: 1px solid #f5f5f5;
  margin-left: 10px;
}

.flex {
  display: flex;
  align-items: center;
}

.line-login {
  width: 32px;
  height: 4px;
  background: #1982e4;
  border-radius: 0px 0px 0px 0px;
  margin: 5px auto 0 auto;
}

.tab-act {
  width: 96px;
  height: 34px;
  font-family: PingFangSC-Medium, PingFangSC-Medium;
  font-weight: 400;
  font-size: 24px;
  color: #1982e4;
}

.right-head-tab {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium, PingFangSC-Medium;
  font-weight: 400;
  font-size: 18px;
  color: #666666;
}

.login-right {
  width: calc(100% - 619px);
  height: 100%;
  padding: 60px;
  box-sizing: border-box;
  background: #fff;
}

.login-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.login-left {
  width: 619px;
  height: 100%;
  position: relative;
}

.login-center {
  width: 1077px;
  height: 600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 1px 1px 1px #f5f5f5;
  border: 1px solid #f5f5f5;
}

.login-box {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.foot-tel {
  position: absolute;
  bottom: 0;
  display: flex;
}

.foot-tel p {
  padding: 0 20px;
  font-weight: 500;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue